import React, { useState } from "react";
import { Modal, Form, Input, notification } from "antd";
import { useModal } from "../../Context/modalContext";
import axios from "axios";
// import { useApi } from '../../Context/apiContext';

const TransportSupportModal = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  // const { apiCall } = useApi();
  const { hideModal } = useModal();

  const handleOk = async () => {
    try {
      setLoading(true); // Start loading
      const values = await form.validateFields(["username", "comments"]); // Validate and get form values
      // Convert form values to FormData
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });

      // Send the FormData to the API
      await axios.post(
        "https://apps.youthplus.ng/onboard/qt/feedback/",
        formData // Pass FormData
      );

      //   console.log("Support Submitted:", response.data);
      notification.success({
        message: "Thank you for contacting us!",
        description: "Your concerns have been logged successfully.",
        duration: 3, // Duration for 3 seconds
        // Position the notification at the bottom-right corner
      });
      form.resetFields();
      hideModal();
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        notification.error({
          message: "Error", // Title of the error notification
          description: `${error.response.data.message}`,
        });
      } else if (error.request) {
        // Request was made but no response received
        notification.error({
          message: "Network Error", // Title of the error notification
          description: `There was an issue with your submission. Please check your network.`,
        });
      } else {
        // Handle other errors
        notification.error({
          message: "Error", // Title of the error notification
          description: ` ${error.response.data.message}`,
        });
      }
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Modal
      title="How can we assist you? "
      open={true} // Since it's conditionally rendered, it's always visible
      onOk={handleOk}
      onCancel={hideModal}
      okText="Submit"
      confirmLoading={loading}
      destroyOnClose
    >
      <p></p>
      <Form
        form={form}
        layout="vertical"
        name="support_form"
        initialValues={{ rating: 0 }}
      >
        <Form.Item
          name="username"
          label="UserName / Email"
          rules={[
            { required: true, message: "Please enter your name" },
            { min: 2, message: "Name must be at least 2 characters" },
          ]}
        >
          <Input placeholder="Your Name" />
        </Form.Item>

        <Form.Item
          name="comment"
          label="Message"
          rules={[
            { required: true, message: "Please enter your feedback" },
            { min: 10, message: "Feedback must be at least 10 characters" },
          ]}
        >
          <Input.TextArea rows={4} placeholder="Your Feedback" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TransportSupportModal;
